import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { newsApi } from "../api/newsApi";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function NewsEdit() {
  const { id } = useParams();
  const nav = useNavigate();

  const [titleAz, setTitleAz] = useState("");
  const [titleEn, setTitleEn] = useState("");
  const [titleRu, setTitleRu] = useState("");

  const [contentAz, setContentAz] = useState("");
  const [contentEn, setContentEn] = useState("");
  const [contentRu, setContentRu] = useState("");

  const [insertedDate, setInsertedDate] = useState("");
  const [updateDate, setUpdateDate] = useState("");
  const [manualInsertedDate, setManualInsertedDate] = useState(null);

  const [youtubeLink, setYoutubeLink] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [hasImage, setHasImage] = useState(false);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const fmt16 = (v) => {
    return v ? String(v).replace("T", " ").slice(0, 16) : "—";
  };

  const parseApiDate = (v) => {
    if (!v) return null;

    const d = new Date(String(v));

    return Number.isNaN(d.getTime()) ? null : d;
  };

  const toLocalDateTimeString = (d) => {
    if (!d) return null;

    const pad = (n) => String(n).padStart(2, "0");

    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
      d.getHours()
    )}:${pad(d.getMinutes())}`;
  };

  const getYoutubeEmbedUrl = (url) => {
    if (!url) return "";

    try {
      const value = String(url).trim();

      if (!value) return "";

      const parsed = new URL(value);

      let videoId = "";

      if (parsed.hostname.includes("youtu.be")) {
        videoId = parsed.pathname.split("/").filter(Boolean)[0] || "";
      }

      if (parsed.hostname.includes("youtube.com")) {
        if (parsed.pathname === "/watch") {
          videoId = parsed.searchParams.get("v") || "";
        }

        if (parsed.pathname.startsWith("/embed/")) {
          videoId = parsed.pathname.replace("/embed/", "").split("/")[0] || "";
        }

        if (parsed.pathname.startsWith("/shorts/")) {
          videoId = parsed.pathname.replace("/shorts/", "").split("/")[0] || "";
        }

        if (parsed.pathname.startsWith("/live/")) {
          videoId = parsed.pathname.replace("/live/", "").split("/")[0] || "";
        }
      }

      if (!videoId) return "";

      videoId = videoId.split("?")[0].split("&")[0];

      return `https://www.youtube.com/embed/${videoId}`;
    } catch {
      return "";
    }
  };

  useEffect(() => {
    const load = async () => {
      setLoading(true);

      try {
        const res = await newsApi.getById(id);
        const d = res.data || {};

        setTitleAz(d.titleAz ?? d.TitleAz ?? "");
        setTitleEn(d.titleEn ?? d.TitleEn ?? "");
        setTitleRu(d.titleRu ?? d.TitleRu ?? "");

        setContentAz(d.contentAz ?? d.ContentAz ?? "");
        setContentEn(d.contentEn ?? d.ContentEn ?? "");
        setContentRu(d.contentRu ?? d.ContentRu ?? "");

        setInsertedDate(d.insertedDate ?? d.InsertedDate ?? "");
        setUpdateDate(d.updateDate ?? d.UpdateDate ?? "");

        setManualInsertedDate(parseApiDate(d.manualInsertedDate ?? d.ManualInsertedDate ?? null));

        setYoutubeLink(d.youtubeLink ?? d.YoutubeLink ?? "");

        setHasImage(Boolean(d.hasImage ?? d.HasImage));
      } catch (e) {
        alert(e?.response?.data || e.message || "Not found");

        nav("/news");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id, nav]);

  const submit = async (e) => {
    e.preventDefault();

    setSaving(true);

    try {
      await newsApi.update(id, {
        titleAz,
        titleEn,
        titleRu,

        contentAz,
        contentEn,
        contentRu,

        manualInsertedDate: toLocalDateTimeString(manualInsertedDate),

        youtubeLink,

        imageFile,
      });

      nav("/news");
    } catch (err) {
      alert(err?.response?.data || err.message || "Update failed");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="card">
        <div className="cardBody">
          Yüklənir...
        </div>
      </div>
    );
  }

  const youtubeEmbedUrl = getYoutubeEmbedUrl(youtubeLink);

  return (
    <div>
      <h1 className="pageTitle">
        Xəbəri redaktə et #{id}
      </h1>

      <div className="grid2">
        <div className="card">
          <div className="cardHead">
            <div className="cardTitle">
              {youtubeEmbedUrl ? "Current Video" : "Current Image"}
            </div>

            <span className="badge badgeOk">
              Preview
            </span>
          </div>

          <div className="cardBody">
            {youtubeEmbedUrl ? (
              <iframe
                title="youtube-video"
                src={youtubeEmbedUrl}
                style={{
                  width: "100%",
                  maxWidth: 520,
                  height: 240,
                  borderRadius: 14,
                  border: "1px solid rgba(255,255,255,.12)",
                  background: "#000",
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            ) : hasImage ? (
              <img
                alt="current"
                src={newsApi.getImageUrl(id) + `?t=${Date.now()}`}
                style={{
                  width: "100%",
                  maxWidth: 520,
                  height: 240,
                  objectFit: "cover",
                  borderRadius: 14,
                  border: "1px solid rgba(255,255,255,.12)",
                }}
              />
            ) : (
              <div
                style={{
                  width: "100%",
                  maxWidth: 520,
                  height: 240,
                  display: "grid",
                  placeItems: "center",
                  borderRadius: 14,
                  border: "1px solid rgba(255,255,255,.12)",
                  color: "rgba(255,255,255,.65)",
                }}
              >
                Şəkil / video yoxdur
              </div>
            )}

            <div style={{ marginTop: 12, opacity: 0.75 }}>
              <div style={{ fontSize: 12, marginBottom: 6 }}>
                InsertedDate (read-only)
              </div>

              <div style={{ fontWeight: 800 }}>
                {fmt16(insertedDate)}
              </div>
            </div>

            <div style={{ marginTop: 10, opacity: 0.75 }}>
              <div style={{ fontSize: 12, marginBottom: 6 }}>
                UpdateDate (read-only)
              </div>

              <div style={{ fontWeight: 800 }}>
                {fmt16(updateDate)}
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="cardHead">
            <div className="cardTitle">
              Update Form
            </div>

            <span className="badge">
              PUT
            </span>
          </div>

          <div className="cardBody">
            <form className="form" onSubmit={submit}>
              <div>
                <span className="label">
                  Title (AZ)
                </span>

                <input
                  className="input"
                  value={titleAz}
                  onChange={(e) => setTitleAz(e.target.value)}
                />
              </div>

              <div>
                <span className="label">
                  Title (EN)
                </span>

                <input
                  className="input"
                  value={titleEn}
                  onChange={(e) => setTitleEn(e.target.value)}
                />
              </div>

              <div>
                <span className="label">
                  Title (RU)
                </span>

                <input
                  className="input"
                  value={titleRu}
                  onChange={(e) => setTitleRu(e.target.value)}
                />
              </div>

              <div className="hr" />

              <div>
                <span className="label">
                  Content (AZ)
                </span>

                <textarea
                  className="textarea"
                  rows={7}
                  value={contentAz}
                  onChange={(e) => setContentAz(e.target.value)}
                />
              </div>

              <div>
                <span className="label">
                  Content (EN)
                </span>

                <textarea
                  className="textarea"
                  rows={7}
                  value={contentEn}
                  onChange={(e) => setContentEn(e.target.value)}
                />
              </div>

              <div>
                <span className="label">
                  Content (RU)
                </span>

                <textarea
                  className="textarea"
                  rows={7}
                  value={contentRu}
                  onChange={(e) => setContentRu(e.target.value)}
                />
              </div>

              <div className="hr" />

              <div>
                <span className="label">
                  Manual inserted date (publish)
                </span>

                <DatePicker
                  className="input"
                  selected={manualInsertedDate}
                  onChange={(d) => setManualInsertedDate(d)}
                  placeholderText="Tarix və saat seç"
                  dateFormat="dd.MM.yyyy HH:mm"
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={5}
                  timeCaption="Saat"
                  isClearable
                />

                <div style={{ marginTop: 6, opacity: 0.65, fontSize: 12 }}>
                  * InsertedDate dəyişmir. Save edəndə UpdateDate avtomatik yazılacaq.
                </div>
              </div>

              <div className="hr" />

              <div>
                <span className="label">
                  YouTube video linki
                </span>

                <input
                  type="url"
                  className="input"
                  value={youtubeLink}
                  onChange={(e) => setYoutubeLink(e.target.value)}
                  placeholder="https://www.youtube.com/watch?v=b30bjZkqulc"
                />

                <div style={{ marginTop: 6, opacity: 0.65, fontSize: 12 }}>
                  Link varsa, public hissədə şəkilin yerində video göstəriləcək. Linki silsən, şəkil görünəcək.
                </div>
              </div>

              <div className="hr" />

              <div>
                <span className="label">
                  New Image (optional)
                </span>

                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setImageFile(e.target.files?.[0] || null)}
                />

                <div style={{ marginTop: 6, opacity: 0.65, fontSize: 12 }}>
                  Video linki boşdursa, şəkil əsas media kimi görünəcək.
                </div>
              </div>

              <div className="btnRow">
                <button className="btn btnPrimary" disabled={saving}>
                  {saving ? "Saving..." : "Save"}
                </button>

                <button type="button" className="btn" onClick={() => nav("/news")}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}